/**
 * Created by Ning Jiang on 4/19/2016.
 */

import { PunkGameConfig } from "../../PunkGameConfig";
import { PunkServerDataParser } from "../PunkServerDataParser";
import { IMysteryData, IStickyJump, IAllWinData, IPunkGameData, IPunkBetWinData } from "./PunkServerData";
import { Point } from "pixi.js";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { IWinRatioConfig } from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../punkEngine/PunkEngineManager";
import { PunkSymbolData } from "../../punkEngine/config/PunkSymbolData";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { ParsedGameData } from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";

export class PunkParsedGameData extends ParsedGameData {

    private readonly _allWinData:IAllWinData;

    private readonly _punkBetWins:IPunkBetWinData[];
    private readonly _nearWinMap:number[][];

    private readonly _respinTriggered:boolean;

    //Area
    private readonly _gameAreaSize:number[];

    // MysterySymbol
    private readonly _mysteryData:IMysteryData;

    // Calculated values
    private readonly _scatterReelPositions:number[];
    private readonly _scatterAmountLanded:number;

    private readonly _mysteryAmountLanded:number;

    private readonly _wildLandPositions:number[];
    private readonly _wildExpands:boolean;
    private readonly _stickyWildPositions:IStickyJump[];

    private readonly _superXways:number[];
    private readonly _multiplierReel:number[];
    private readonly _freespinTrain:string[];

    private readonly _expandingMultiplyValues:number[];

    // private readonly _
    private readonly _isPlayData:boolean = true;

    public get isPlayData():boolean{
        return this._isPlayData;
    }

    public get nearWinMap():number[][] {
        return this._nearWinMap;
    }

    public get punkBetWins():IPunkBetWinData[] {
        return this._punkBetWins;
    }

    public get respinTriggered():boolean{
        return this._respinTriggered;
    }

    public get allWinData():IAllWinData {
        return this._allWinData;
    }
    

    public get freespinTrain():string[] {
        return this._freespinTrain;
    }

    public get mysteryData():IMysteryData | null {
        return this._mysteryData;
    }

    public get gameAreaSize():number[]{
        return this._gameAreaSize;
    }

    public get scatterReelPositions():number[]{
        return this._scatterReelPositions;
    }

    public get scatterLandAmount():number{
        return this._scatterAmountLanded;
    }

    public get mysteryAmountLanded():number{
        return this._mysteryAmountLanded;
    }

    public get wildLandPositions():number[]{
        return this._wildLandPositions;
    }

    public get wildExpands():boolean{
        return this._wildExpands;
    }

    public get stickyJumpPositions():IStickyJump[]{
        return this._stickyWildPositions;
    }

    public get superXways():number[]{
        return this._superXways;
    }

    public get multiplierReel():number[]{
        return this._multiplierReel;
    }

    public get expandingMultiplyValues():number[]{
        return this._expandingMultiplyValues;
    }

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    constructor(rawData:IPunkGameData, dataParser:PunkServerDataParser) {
        super(rawData, dataParser);


        // Calculated values.
        // this._currentWinRatio = this._singleWin / this._playedBetValue;
        // this._isBigWin = this._currentWinRatio >= PunkGameConfig.instance.WIN_RATIOS.bigWin[0].ratio;
        // this._currentWinRatioConfig = PunkParsedGameData.getWinRatioConfig(this._currentWinRatio);
        this._punkBetWins = rawData.betWayWins! as IPunkBetWinData[];

        this._respinTriggered = !!rawData.respinTriggered;

        this._mysteryData = dataParser.parseMysteryData(rawData);
        this._gameAreaSize = dataParser.parseGameAreaSize(rawData);
        this._superXways = dataParser.parseSuperXways(rawData);
        this._multiplierReel = dataParser.parseMultiplierReel(rawData);

        this._freespinTrain = dataParser.parseFreespinTrain(rawData);

        this._stickyWildPositions = this.decryptStickyJumpPosition(dataParser.parseStickyWildPositions(rawData));

        this._wildLandPositions = this.findOneSymbol(ReelSymbolName.WILD);
        this._scatterReelPositions = this.findOneSymbol(ReelSymbolName.SCATTER);
        this._scatterAmountLanded = this.countArrayPos(this._scatterReelPositions);

        this._mysteryAmountLanded = this.countArrayPos(this.findOneSymbol(ReelSymbolName.MYSTERY));

        this._wildExpands = this.findExpandWild();

        this._punkBetWins = this.parseSpecialBetWins();
        this._allWinData = this.parseAllHits();
        this._nearWinMap = this.createNearWinMap();

        this._expandingMultiplyValues = this.calculateMultiWaysValues(rawData);

        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    private calculateMultiWaysValues(rawData:IPunkGameData):number[]{
        const temp:number[] = [];
        if(this.mysteryData){
            const nrOfReels:number = this.mode == GameMode.NORMAL ? 5 : 6;
            let calcValues:number[] = ArrayHelper.initArrayWithValues(nrOfReels,() => 3)
            calcValues[0] = rawData.gameAreaSize[0];

            for(let reel:number = 0; reel < nrOfReels; reel++){
                let total:number = calcValues[0];
                calcValues[reel] = rawData.gameAreaSize[reel];
                for(let i:number = 1; i < calcValues.length; i++){
                    total *= calcValues[i];
                }
                temp.push(total);
            }
        }
        return temp;
    }

    private decryptStickyJumpPosition(value:string):IStickyJump[]{
        if(value == "") return [];

        const res:IStickyJump[] = [];
        const amountOfWilds:string[] = value.split(";");
        
        for(let i = 0; i < amountOfWilds.length-1;i++){
            const dataTypes:string[] = amountOfWilds[i].split(":");
            const positions:Point[] = [];
            for(let j = 0; j < dataTypes.length-1; j++){
                const positionX:number = parseFloat(dataTypes[j].split(",")[0]);
                const positionY:number = parseFloat(dataTypes[j].split(",")[1]);
                positions.push(new Point(positionX, positionY));
            }

            const jumpData:IStickyJump = {from: positions[0], to: positions[1], mult:parseFloat(dataTypes[2]), multNew:parseFloat(dataTypes[3])  }
            res.push(jumpData);
        }
        return res;
    }

    private findExpandWild():boolean{
        for(let reel = 0; reel < this._wildLandPositions.length;reel++){
            if(this._wildLandPositions[reel] > 0 && PunkEngineManager.getReel(reel).isActive) return true;
        }
        return false;
    }

    private parseAllHits():IAllWinData{
        let allWinData:IAllWinData = {
            symbols:[],
            longest:0,
            reelWinPositions:[],
            totalWinCombination:0,
        };

        for(let i:number = 0; i < this.gameAreaSize.length;i++){
            allWinData.reelWinPositions.push([])
            for(let j:number = 0; j < this.gameAreaSize[i];j++)
                allWinData.reelWinPositions[i].push(false);
        }

        for(let groups = 0; groups < this._punkBetWins.length;groups++){
            const winData:IPunkBetWinData = this._punkBetWins[groups];
            allWinData.symbols.push(winData.symbol);
            allWinData.totalWinCombination += winData.numberOfCombinations;
            if(winData.length > allWinData.longest) allWinData.longest = winData.length;
            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                for(let row = 0; row < posRow.length; row++){
                    if(posRow[row])allWinData.reelWinPositions[reel][row] = posRow[row];
                }
            }
        }
        return allWinData;
    }

    private findOneSymbol(symbol:string):number[]{
        let arr:number[] = [];

        const skipOverflowBott:number = 1;
        for(let reel = 0; reel < this.reels.length; reel++){
            let pos:number = -1;
            for(let row = skipOverflowBott; row < this._gameAreaSize[reel] + skipOverflowBott; row++){
                if(this.reels[reel][row] == symbol){
                    pos = row-skipOverflowBott;
                    for(let jw:number = 0; jw < this._stickyWildPositions.length;jw++){
                        const posJw:Point = this._stickyWildPositions[jw].to;
                        if(posJw.x != reel) continue;
                        if(posJw.y == pos) pos = -1;
                        break;
                    }
                    break;
                } 
            }
            if(this._mysteryData.mysterySymbolOnReel[reel]) pos = -1;
            arr.push(pos);
        }
        return arr;
    }

    private countArrayPos(arr:number[]):number{
        let count:number = 0;
        arr.forEach(val => { if(val >= 0) count++;});
        return count;
    }

    private parseSpecialBetWins():IPunkBetWinData[]{

        let isMultiSym:boolean = this.mysteryData!.mysterySymbolRevealed != "" &&  PunkSymbolData.getSymbolConfig(this.mysteryData!.mysterySymbolRevealed).MULTISIZE!;
        
        for(var i = 0; i < this._punkBetWins.length;i++){
            let winPositions:boolean[][] = [];
            let res:IPunkBetWinData = this._punkBetWins[i];

            for(let reel:number = 0; reel < PunkEngineManager.AllReels.length; reel++){
                if(res.reelWinPositions[reel].indexOf(true) == -1) continue;
                winPositions[reel] = [];
                for(let row:number = 0; row < this.gameAreaSize[reel]; row++)
                    winPositions[reel].push(res.reelWinPositions[reel][row]);
            }

            for(let reel:number = 0; reel < winPositions.length; reel++){
                if(this.mysteryData!.mysterySymbolOnReel[reel] && isMultiSym){
                    if(res.symbol === this.mysteryData!.mysterySymbolRevealed){
                        let removeStart:number = this.mysteryData!.mysterySymbolPositions[reel];
                        let removeTo:number = removeStart+this.mysteryData!.mysterySymbolSize[reel];
                        for(let rem:number = removeStart+1; rem < removeTo; rem++){
                            winPositions[reel][rem] = false;
                        }
                    }
                    let shiftStart:number = (this.mysteryData!.mysterySymbolSize[reel]-1) ;
                    for(let shift:number = shiftStart; shift < winPositions[reel].length; shift++){
                        if(winPositions[reel][shift] && shift > this.mysteryData!.mysterySymbolPositions[reel]){
                            winPositions[reel][shift] = false;
                            winPositions[reel][shift-shiftStart] = true;
                        }
                    }
                }
            }
            this._punkBetWins[i].reelWinPositions = winPositions;

            let hitCounter:number = 0;
            for(let reel:number = 0; reel < winPositions.length; reel++){
                let rowHits:number = 0;
                for(let row:number = 0; row < winPositions[reel].length; row++){
                    if(winPositions[reel][row])
                        rowHits++;
                }
                if(rowHits != 0) hitCounter = reel == 0 ? rowHits : hitCounter*rowHits;
            }
            this._punkBetWins[i].hits = hitCounter;
        }
        
        return this._punkBetWins;
    }

    // TODO: this doesn't take care of the win lower than the configed lowest win level. we can solve it by defining TINY_WIN ratio:0.001. but this is not the best way.
    private static getPunkWinRatioConfig(winRatio:number):IWinRatioConfig | null {
        let winLevels:IWinRatioConfig[] = PunkGameConfig.instance.WIN_RATIOS.normalWin.concat();
        winLevels = winLevels.concat(PunkGameConfig.instance.WIN_RATIOS.bigWin);

        for(let i:number = winLevels.length - 1; i >= 0; i--) {
            const winLevel = winLevels[i];
            if(winRatio > winLevel.ratio) {
                return winLevel;
            }
        }
        return null;
    }

    protected createNearWinMap():number[][]{

        // For some reason, this is the only solution i got to bypass the reference.
        const reelCopied:string[][] = [];
        for(let i = 0; i < this.reels.length;i++){
            reelCopied.push(Array.from(this.reels[i]));
        }

        let maxWays:number = this._gameAreaSize[0];
        for(let k = 1; k < this.reels.length;k++){
            maxWays *= this._gameAreaSize[k];
        }

        const reelHightMaximus:number = maxWays == Math.pow(6,6) && this.mode == GameMode.FREESPIN ? 6 : 3;

        
        let startM:number[] = ArrayHelper.initArrayWithValues(reelHightMaximus,(index:number) => {return index;});
        let map:number[][] = [startM];

        for(let jumpPos:number = 0; jumpPos < this.stickyJumpPositions.length;jumpPos++){
            const reel:number = this.stickyJumpPositions[jumpPos].to.x;
            const row:number = this.stickyJumpPositions[jumpPos].to.y+1;
            reelCopied[reel][row] = ReelSymbolName.WILD;
        }

        for(let wildReel:number = 0; wildReel < this.wildLandPositions.length;wildReel++){
            if(this.wildLandPositions[wildReel] == -1) continue;
            for(let row:number = this.wildLandPositions[wildReel]; row >= 0; row--){
                reelCopied[wildReel][row] = ReelSymbolName.WILD;
            }
        }

        let specialStartPos:number = -1;
        // Create normal map for symbols that crosses itself and special symbols.
        for(let symPos:number = 0; symPos < reelHightMaximus; symPos++){
            let startSym:string = reelCopied[0][symPos+PunkGameConfig.instance.REEL_ENGINE_CONFIG.OVERFLOW_BOTT];
            let isSpecial:boolean = startSym == ReelSymbolName.WILD || startSym == ReelSymbolName.MYSTERY;
            if(!isSpecial){
                for(let reel:number = 1; reel < PunkEngineManager.AllReels.length;reel++){
                    let arrFindings:number[] = findSymbolPos(reel, [startSym, ReelSymbolName.WILD, ReelSymbolName.MYSTERY]);
                    if(arrFindings.length == 0) break;
                    if(map.length == reel)
                        map.push([]);

                    for(let j:number = 0; j < arrFindings.length;j++) 
                        if(map[reel].indexOf(arrFindings[j]) == -1 ) map[reel].push(arrFindings[j]);
                    if(map[reel].length == 0){
                        map.pop();
                        break;
                    }
                }
            }else{
                for(let reel:number = 0; reel < PunkEngineManager.AllReels.length; reel++){
                    if(map.length == reel)
                        map.push([]);
                    
                    if(findSpecialSymbol(reel)) specialStartPos = reel+1;
                    else break;

                    for(let pos:number = PunkGameConfig.instance.REEL_ENGINE_CONFIG.OVERFLOW_BOTT; pos < PunkEngineManager.getReel(reel).windowAmount;pos++){
                        if(map[reel].indexOf(pos) == -1) map[reel].push(pos);
                    }
                }
            }
        }

        // Push the startpoint to where the specialsymbol stops being used.
        if(specialStartPos != -1){
            for(let symPos:number = 0; symPos < PunkEngineManager.getReel(specialStartPos).windowAmount; symPos++){
                let startSym:string = reelCopied[specialStartPos][symPos+PunkGameConfig.instance.REEL_ENGINE_CONFIG.OVERFLOW_BOTT];
                for(let reel:number = specialStartPos; reel < PunkEngineManager.AllReels.length;reel++){
                    const arrFindings:number[] = findSymbolPos(reel, [startSym, ReelSymbolName.WILD, ReelSymbolName.MYSTERY]);
                    if(map.length == reel)
                        map.push([]);
                    for(let j:number = 0; j < arrFindings.length;j++) 
                        if(map[reel].indexOf(arrFindings[j]) == -1 ) map[reel].push(arrFindings[j]);
                    if(map[reel].length == 0){
                        map.pop();
                        break;
                    }
                }
            }
        }
        
        function findSpecialSymbol(reel:number):boolean{
            for(let symPos:number = 0; symPos < reelHightMaximus; symPos++){
                const sym:string  = reelCopied[reel][symPos+1];
                if([ReelSymbolName.WILD, ReelSymbolName.MYSTERY].indexOf(sym) >= 0) return true;
            }
            return false;
        }

        function findSymbolPos(reel:number,symbol:string[]):number[]{
            let temp:number[] = [];
            for(let symPos:number = 0; symPos < reelHightMaximus; symPos++){
                if(symbol.indexOf(reelCopied[reel][symPos+1]) >= 0 && temp.indexOf(symPos) == -1) temp.push(symPos);
            }
            return temp;
        }

        return map;
    }

    protected parseScatterPositions(rawData:IPunkGameData, dataParser:PunkServerDataParser):number[] | undefined {
        return dataParser.parseScatterPositions(rawData);
    }
}